define('common/matomoHelper',[
],
    function () {

        function trackFormSubmit(formId) {
            if (window._paq) {
                if (formId.startsWith("#")) formId = formId.substring(1);
                _paq.push(['FormAnalytics::trackFormSubmit', document.getElementById(formId)]);
            }
        }

        function trackFormConversion(formId) {
            if (window._paq) {
                if (formId.startsWith("#")) formId = formId.substring(1);
                _paq.push(['FormAnalytics::trackFormConversion', document.getElementById(formId)]);
            }
        }

        return {
            trackFormSubmit: trackFormSubmit,
            trackFormConversion: trackFormConversion
        };
    });

